import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { declineJobModalStyles } from "./styles";
import { useTranslation } from "react-i18next";

const DeclineJobModal = ({ open, onClose, onActionClick, isLoading }) => {
  const { t } = useTranslation("job-action-modals", {
    keyPrefix: "declineJobModal",
  });
  const {
    dialogTitleBoxStyle,
    dialogTitleStyle,
    dialogContent,
    dialogContentTextStyle,
    dialogActions,
    backButtonStyle,
    cancelButtonStyle,
    loader,
  } = declineJobModalStyles;

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: 4,
          maxWidth: "556px",
          width: "100%",
        },
      }}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
    >
      <Box sx={dialogTitleBoxStyle}>
        <DialogTitle sx={dialogTitleStyle}>{t("dialogTitle")}</DialogTitle>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" sx={{ color: "rgba(62, 63, 76, 1)" }} />
        </IconButton>
      </Box>

      <DialogContent sx={dialogContent}>
        <Typography sx={dialogContentTextStyle}>
          {t("dialogContentText")}
        </Typography>
      </DialogContent>

      <DialogActions sx={dialogActions}>
        <Button variant="contained" sx={backButtonStyle} onClick={onClose}>
          {t("backButton")}
        </Button>

        <Button
          onClick={onActionClick}
          disabled={isLoading}
          sx={cancelButtonStyle}
        >
          {t("cancelButton")}
          {isLoading && <CircularProgress size={20} sx={loader} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeclineJobModal;
